__turbopack_context__.v({
  "className": "jetbrains_mono_b525ea9a-module__DklFWW__className",
  "variable": "jetbrains_mono_b525ea9a-module__DklFWW__variable",
});
